import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';
import tinycolor from 'tinycolor2';

import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { ColorInput } from '@process-advisor/process-miner/components/shared/colorInput';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { type ActivityColorsProps } from '@process-advisor/process-miner/api/methods/settings/changeActivityColors';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;


const StyledColorInput = styled(ColorInput)`
    margin-right: 10px;

    &:last-child {
        margin: 0
    }
`;

export const ActivityColors = () => {
    const [
        initialColors,
        setInitialColors,
    ] = React.useState<ActivityColorsProps>({});
    const [ activityTypes, setActivityTypes] = React.useState([]);
    let currentKey = '';
    const changeColor = _.curry((key: string, color: string) => {

        currentKey = key;
        apiProvider.changeActivityColors({ [key]: tinycolor(color).toRgbString() });
    });

    const onClose = () => {
        if (currentKey !== 'visualizerBackgroundColor') {
            apiProvider.rebuildPVDiagram({});
        } else {
            apiProvider.eventEmitter.emit(Event.changeVisualizerBackgroundColor);
        }
    };

    React.useEffect(() => {
        setActivityTypes(apiProvider.getActivityTypes());
        setInitialColors(apiProvider.getActivityColors());
    }, []);


    React.useEffect(() => {
        const listener = () =>
            setInitialColors(apiProvider.getActivityColors());
            setActivityTypes(apiProvider.getActivityTypes());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <div>
            <Wrapper>
                <SingleBlock width="30%">
                    <Section title={activityTypes[0]}/>
                </SingleBlock>
                <SingleBlock width="20%">
                    <StyledColorInput
                        id='fill1'
                        onClose={onClose}
                        onColorChange={changeColor('fill_color1')}
                        label='Fill'
                        color={initialColors.fill_color1} />
                </SingleBlock>
                <SingleBlock width="20%">                    
                    <StyledColorInput
                        id='text1'
                        onClose={onClose}
                        onColorChange={changeColor('text_color1')}
                        label='Text'
                        color={initialColors.text_color1} />
                </SingleBlock>
                <SingleBlock width="20%">
                    <StyledColorInput
                        id='select1'
                        onClose={onClose}
                        onColorChange={changeColor('select_color1')}
                        label='Select'
                        color={initialColors.select_color1} />
                </SingleBlock>
            </Wrapper>
            { activityTypes.length === 2 ?
            <Wrapper>
                <SingleBlock width="30%">
                    <Section title={activityTypes[1]}/>
                </SingleBlock>
                <SingleBlock width="20%">
                    <StyledColorInput
                        id='fill2'
                        onClose={onClose}
                        onColorChange={changeColor('fill_color2')}
                        label='Fill'
                        color={initialColors.fill_color2} />
                </SingleBlock>
                <SingleBlock width="20%">
                    <StyledColorInput
                        id='text2'
                        onClose={onClose}
                        onColorChange={changeColor('text_color2')}
                        label='Text'
                        color={initialColors.text_color2} />
                </SingleBlock>
                <SingleBlock width="20%">
                    <StyledColorInput
                        id='select2'
                        onClose={onClose}
                        onColorChange={changeColor('select_color2')}
                        label='Select'
                        color={initialColors.select_color2} />
                </SingleBlock>
            </Wrapper>
            : '' }

            { activityTypes.length === 3 ?
            <Wrapper>
                <SingleBlock width="30%">
                    <Section title={activityTypes[2]}/>
                </SingleBlock>
                <SingleBlock width="20%">
                    <StyledColorInput
                            id='fill3'
                            onClose={onClose}
                            onColorChange={changeColor('fill_color3')}
                            label='Fill'
                            color={initialColors.fill_color3} />
                </SingleBlock>
                <SingleBlock width="20%">                        
                    <StyledColorInput
                        id='text3'
                        onClose={onClose}
                        onColorChange={changeColor('text_color3')}
                        label='Text'
                        color={initialColors.text_color3} />
                </SingleBlock>
                <SingleBlock width="20%">
                    <StyledColorInput
                        id='select3'
                        onClose={onClose}
                        onColorChange={changeColor('select_color3')}
                        label='Select'
                        color={initialColors.select_color3} />
                </SingleBlock>
            </Wrapper>
            : '' }

        </div>
    );
};


/*


*/